export enum BlockType {
  Card = 'card',
  Columns = 'columns',
  Cover = 'cover',
  Description = 'description',
  Gallery = 'gallery',
  Gif = 'gif',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  Image = 'image',
  Incut = 'incut',
  Intro = 'intro',
  Line = 'line',
  List = 'list',
  Meta = 'meta',
  MoreOnTopic = 'moreOnTopic',
  NewsSource = 'newsSource',
  Preview = 'preview',
  Quiz = 'quiz',
  Quote = 'quote',
  SeoTitle = 'seoTitle',
  SpecLink = 'specLink',
  Subtitle = 'subtitle',
  Test = 'test',
  TestQuestion = 'testQuestion',
  TestResults = 'testResults',
  Text = 'text',
  Video = 'video',
  Widget = 'widget',
}
